import $ from 'jquery'

const showDelayText = (info, delay) => {
  setTimeout(() => {
    $('.vld-icon').after('<p class="loading-text">' + info + '</p>')
  }, delay)
}

export {
  showDelayText
}



// WEBPACK FOOTER //
// ./src/plugins/delayhandler.js